import localforage from 'localforage';
import React, { FunctionComponent, ReactElement, useEffect, useState } from 'react';

// Api
import { optionApi } from '../../../api/optionApi';

// Types and constants
import { OptionModel } from '../../../shared/types';

// Components
import OptionsList from './OptionsList/OptionsList';

interface OptionsProps {

}

const Options: FunctionComponent<OptionsProps> = (props: OptionsProps): ReactElement => {
  const [optionList, setOptionList] = useState<OptionModel[]>([]);
  const [openDeleteOptionDialog, setOpenDeleteOptionDialog] = useState<boolean>(false);
  const [optionToDelete, setOptionToDelete] = useState<OptionModel>({} as OptionModel);
  const [openErrorDialog, setOpenErrorDialog] = useState<boolean>(false);
  const [error, setError] = useState<any>();

  const loadOptions = async () => {
    let response: OptionModel[] = await optionApi.getOptions();
    console.log({ response });
    response = response.map((item) => {
      return item;
    });

    setOptionList(response);
    localforage.setItem('options', response);
  };

  const addOption = (option: OptionModel) => {
    setOptionList([option, ...optionList]);
  }

  const saveOption = async (option: OptionModel) => {
    try {
      // If option does not exist then create a new option otherwise update the existing one. 
      const found = optionList.find((o) => o.type === option.type);
      if (!found) {
        await optionApi.createOption(option);
      } else {
        await optionApi.updateOption(option);
      }

      loadOptions();
    } catch (error) {
      setOpenErrorDialog(true);
      setError(error);
    }
  }

  const deleteOptionHandler = (option: OptionModel) => {
    setOptionToDelete(option);
    setOpenDeleteOptionDialog(true);
  }

  const deleteOption = async (optionType: string) => {
    try {
      await optionApi.deleteOption(optionType);
      setOptionList([...optionList].filter((o) => o.type !== optionType));
      setOpenDeleteOptionDialog(false);
    } catch (error) {
      setOpenErrorDialog(true);
      setError(error);
    }
  }

  const handleClose = () => {
    setOpenDeleteOptionDialog(false);
    setOpenErrorDialog(false);
  }

  const handleExpandCollapse = (option: OptionModel) => {
    const newOptionList = [...optionList];
    const foundIndex = newOptionList.findIndex((o) => o.type === option.type);
    if (foundIndex >= 0) {
      newOptionList[foundIndex].isOpen = !option.isOpen;
      setOptionList(newOptionList);
    }
  };

  useEffect(() => {
    loadOptions();
  }, []);

  return (
    <div data-testid='options-container'>
      {
        optionList && optionList.length > 0 && (
          <OptionsList
            optionList={optionList}
            optionToDelete={optionToDelete}
            openDeleteOptionDialog={openDeleteOptionDialog}
            openErrorDialog={openErrorDialog}
            error={error}
            addOption={addOption}
            saveOption={saveOption}
            deleteOption={deleteOption}
            deleteOptionHandler={deleteOptionHandler}
            handleExpandCollapse={handleExpandCollapse}
            handleClose={handleClose}
          />
        )
      }
    </div>
  )
};

export default Options;
